import styled from 'styled-components'

export const Content = styled.div`
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  padding: 30px;
`

export const Action = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/pages/CreateBrand/styles.js